var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOccupied = function SvgIconOccupied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FB",
    d: "M28.402 2.744C-10.692 7.334.374 46.147 10.351 66.565c9.782 17.851 22.71 19.018 49.263 12.018 24.807-6.54 38.666-17.735 27.719-48.537C77.008.996 73.124-2.506 28.403 2.744"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.651,
    cy: 41.225,
    r: 24.663,
    fill: "#CFE4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    d: "M45.453 13.689c13.49 0 24.424 10.934 24.424 24.423a24.3 24.3 0 0 1-2.27 10.297m-7.068 8.913a25 25 0 0 0 2.394-2.151m-6.944 4.982a24.3 24.3 0 0 1-10.536 2.383c-13.489 0-24.424-10.935-24.424-24.424 0-10.272 6.343-19.064 15.325-22.672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.415 38.688h23.394a2.359 2.359 0 1 1 0 4.718H35.415a2.359 2.359 0 0 1 0-4.718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D5B68",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M37.943 36.33h-2.529a2.36 2.36 0 0 0-2.358 2.358v0a2.36 2.36 0 0 0 2.358 2.359h20.291a2.36 2.36 0 0 0 2.359-2.359v0a2.36 2.36 0 0 0-2.359-2.359H41.271"
  })));
};
export default SvgIconOccupied;